import { Helmet } from 'react-helmet-async';
import HeroSection from "./sections/Hero";
import FeaturesSection from "./sections/Features";
import SmartAISection from "./sections/SmartAISection";
import QuickBooksSections from "./sections/QuickBooks";
import WhyChooseSection from "./sections/WhyChoose";
import TestimonialsSection from "./sections/Testimonials";
import FAQSection from "./sections/FAQ";
import CTASection from "./sections/CTA";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>AI-Powered Tools for Home Improvement Pros | Fast Estimates, Invoices & More | MrJoe.Pro</title>
        <meta name="description" content="MrJoe.Pro: AI-powered contractor software for home improvement professionals. Create estimates and invoices in minutes, manage projects, track customers, and integrate with QuickBooks. Built for contractors who need simple, effective tools." />
        <meta name="keywords" content="contractor software, AI estimates, invoicing software, home improvement software, construction management, QuickBooks integration, contractor CRM, estimate generator, project management for contractors" />
        <link rel="canonical" href="https://mrjoe.pro/" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mrjoe.pro/" />
        <meta property="og:title" content="AI-Powered Tools for Home Improvement Pros | MrJoe.Pro" />
        <meta property="og:description" content="Create estimates and invoices in minutes with AI-powered tools built for home improvement contractors. Simple, fast, and effective." />
        <meta property="og:image" content="https://mrjoe.pro/mrjoe_logo_color.svg" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AI-Powered Tools for Home Improvement Pros | MrJoe.Pro" />
        <meta name="twitter:description" content="Create estimates and invoices in minutes with AI-powered tools built for home improvement contractors." />
        <meta name="twitter:image" content="https://mrjoe.pro/mrjoe_logo_color.svg" />
      </Helmet>

      <HeroSection />
      <FeaturesSection />
      <SmartAISection />
      <QuickBooksSections />
      <WhyChooseSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
    </>
  );
}